import { useMemo, useState } from "react";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import { movies } from "@/lib/content";

const tabs = ["全部", "剧情", "悬疑", "爱情", "古装"];

export default function EditorPicks() {
  const [activeTab, setActiveTab] = useState("全部");

  const list = useMemo(() => {
    if (activeTab === "全部") return movies.slice(0, 6);
    return movies.filter((movie) => movie.genres.includes(activeTab)).slice(0, 6);
  }, [activeTab]);

  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Editor's Picks"
        title="编辑精选剧集"
        description="从近期更新的剧集里挑出六部最值得投入时间的作品，每一部都附有完整的剧情解析与看点梳理。"
        actionLabel="查看全部剧集"
        actionTo="/category"
      >
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(tab)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors whitespace-nowrap sm:text-sm ${
                activeTab === tab
                  ? "bg-primary-900 text-background-50"
                  : "text-foreground-600 hover:text-primary-700"
              }`}
              aria-pressed={activeTab === tab}
            >
              {tab}
            </button>
          ))}
        </div>
      </SectionHeading>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {list.map((movie, index) => (
          <MovieCard key={movie.id} movie={movie} index={index} />
        ))}
      </div>

      {list.length === 0 && (
        <div className="mt-8 rounded-lg border border-dashed border-background-300 py-16 text-center">
          <p className="text-sm text-foreground-500">该类型暂无精选内容，换个分类看看吧。</p>
        </div>
      )}
    </section>
  );
}